import { type GetTranslationInput, type GetTranslationResponse, type TranslationDumpSnapshot, type Translation } from './model'
import { Dexie as BaseDexie, type IndexableType } from 'dexie'
import { type TranslationTable, translationSchema } from './db/tables/translation'

export const getTranslationV2 = async (request: GetTranslationInput, db: TranslationTable | null): Promise<GetTranslationResponse> => {
  if (request.phrase.length !== 1) {
    return await Promise.reject(new Error('Invalid phrase'))
  }

  // remove leading non-alphanumeric characters
  let phrase = request.phrase[0].replace(/^[^\p{L}\p{N}]+/u, '').toLowerCase()
  // remove trailing non-alphanumeric characters
  phrase = phrase.replace(/[^\p{L}\p{N}]+$/u, '')
  console.log('phrase: ' + phrase)
  let dbResults: Translation[] = []
  if (db?.translation !== undefined) {
    dbResults = await db.translation.where('word').equals(phrase).distinct().toArray()
  }

  console.log(dbResults)
  return await Promise.resolve({
    responseMessage: dbResults.length === 0 ? '' : dbResults[0].definition,
    translations: dbResults
  })
}

export const persistDump = async (dump: TranslationDumpSnapshot): Promise<IndexableType> => {
  console.log('persisting dump. count: ' + dump.translationDump.translations.length)
  const db = await loadIndexDb()
  console.log('db loaded for peristing')
  const res = await db.translation.bulkPut(dump.translationDump.translations)
  console.log('persitinc complete')
  return res
  // return await db.translation.bulkPut(dump.translationDump.translations)
}

export const queryDb = async (word: string): Promise<Translation[]> => {
  const db = await loadIndexDb()
  return await db.translation.where('word').equals(word).distinct().toArray()
}

export const loadIndexDb = async (): Promise<TranslationTable> => {
  // add table types to union type
  type DexieTables = & TranslationTable
  type Dexie<T = DexieTables> = BaseDexie & T

  const db = new BaseDexie('translationDb') as Dexie

  // add schemas to array
  const schema = Object.assign({},
    translationSchema
  )
  console.log('running db. version')
  db.version(1).stores(schema)
  console.log('db. version complete')
  try {
    console.log('awiting db open')
    await db.open()
    console.log('db opened succesfully')
  } catch (error) {
    console.error('Failed to open database:', error)
    throw error
  }
  return db
}
